// extracted by mini-css-extract-plugin
export var active = "MainNavigation-module--active--db639";
export var link = "MainNavigation-module--link--6bbad";
export var linkWrapper = "MainNavigation-module--linkWrapper--098d7";
export var root = "MainNavigation-module--root--24458";